import { render, staticRenderFns } from "./SpousePartnerResetPassword.vue?vue&type=template&id=e25c3f28&"
import script from "./SpousePartnerResetPassword.vue?vue&type=script&lang=js&"
export * from "./SpousePartnerResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports